module.exports = __webpack_public_path__ + "assets/img/car01.ada5e437.jpg";